import type { SheetGroup } from './sheetFigures'
import type { ExportTable } from './reportExport'

// Clock times as the database holds them ("06:00:00"), shortened to HH:MM.
const clock = (time: string | null) => (time ? time.slice(0, 5) : null)

export function assignmentSheetTable(groups: SheetGroup[], input: { date: string; team: string; generatedAt: Date }): ExportTable {
  return {
    title: 'Daily Assignment Sheet',
    parameters: [
      { label: 'Date', value: input.date },
      { label: 'Team', value: input.team },
    ],
    generatedAt: input.generatedAt,
    columns: [
      { header: 'Assignment', width: 24 },
      { header: 'Employee', width: 22 },
      { header: 'Identifier' },
      { header: 'Start' },
      { header: 'End' },
      { header: 'Activity', width: 24 },
    ],
    rows: groups.flatMap((group) =>
      group.people.map((person) => [
        group.assignment,
        person.employee,
        person.identifier,
        clock(person.startTime),
        clock(person.endTime),
        person.activity,
      ]),
    ),
  }
}
